import {
  Box,
  Button,
  Popover,
  Radio,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import { reducerUpdateAdvanceSearch } from 'src/features/advanceSearchEcommerce';
import FloatingLabelButton from '../FloatingLabelButton';

const options = ['All Reviews', 'Reviews with Comments only'];

export default function FilterWithComment() {
  const theme = useTheme();
  const { withComment } = useAppSelector(
    (state) => state.storeAdvancedSearchEcommerce
  );
  const [open, setOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const dispatch = useAppDispatch();

  const advanceSearchEcommerce = useAppSelector(
    (state) => state.storeAdvancedSearchEcommerce
  );

  const [selectedWithCommentLocal, setSelectedWithCommentLocal] =
    useState<string>(options[0]);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  const handleWithCommentCheckChange = (row: string) => {
    if (row === options[0]) {
      setSelectedWithCommentLocal(options[0]);
    } else {
      setSelectedWithCommentLocal(options[1]);
    }
  };

  const handleApply = () => {
    dispatch(
      reducerUpdateAdvanceSearch({
        ...advanceSearchEcommerce,
        withComment: selectedWithCommentLocal === options[0] ? false : true
      })
    );
    handleClose();
  };

  useEffect(() => {
    setSelectedWithCommentLocal(withComment ? options[1] : options[0]);
  }, [withComment]);

  return (
    <>
      <Stack maxWidth="400px" width="100%" spacing={0.5}>
        <FloatingLabelButton
          chipList={
            withComment ? ['Reviews with Comments only'] : ['All Reviews']
          }
          label="Reviews Type"
          onClick={handleOpen}
          open={open}
        />
      </Stack>
      <Popover
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <Box sx={{ p: theme.spacing(2), maxWidth: '600px', width: '100%' }}>
          <Box
            sx={{
              maxHeight: '300px',
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: 1
            }}
          >
            <>
              {options.map((row) => (
                <Stack direction="row" gap={1} key={row} alignItems="center">
                  <Radio
                    color="primary"
                    checked={selectedWithCommentLocal === row}
                    onChange={() => handleWithCommentCheckChange(row)}
                  />
                  <Typography>
                    {row.charAt(0).toUpperCase() + row.slice(1)}
                  </Typography>
                </Stack>
              ))}
            </>
          </Box>
          <Stack pt={2} alignItems="center">
            <Button variant="contained" onClick={handleApply}>
              Apply
            </Button>
          </Stack>
        </Box>
      </Popover>
    </>
  );
}
